import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CourseListInstructor } from '../../../../shared/interface/course.interface';
import { AlertService } from '../../../../shared/services/alert.service';
import { CrudPromiseService } from '../../../../shared/services/crud-promise.service';

@Injectable({
    providedIn: 'root'
})
export class CourseListRegistrarInstructorService extends CrudPromiseService<CourseListInstructor> {

    constructor(protected http: HttpClient, protected alert: AlertService) {
        super(http, 'courseListInstructor', alert);
    }
}
